import styled, { keyframes } from 'styled-components'

export const HR = styled.div`
  z-index: 0;
  position: absolute;
  top: 42%;
  left: calc(50% - 50vw);
  width: 100vw;
  height: 2px;
  background-color: #d8d8d8;

  @media (max-width: 1024px) {
    top: 289px;
  }

  @media (max-width: 630px) {
    top: 30px;
    left: calc(50% - 1px);
    height: calc(100% - 130px);
    width: 1px;
  }
`

export const Timeline = styled.div<{ isFullSlide: boolean }>`
  height: 550px;
  width: 80%;
  position: relative;
  display: flex;
  justify-content: ${(props) =>
    props.isFullSlide ? 'space-between' : 'space-evenly'};
  align-items: center;
  z-index: 3;
  margin: 0 auto 100px;

  @media (max-width: 1050px) {
    height: 400px;
    margin-top: -60px;
    margin-bottom: 70px;
  }
  @media (max-width: 630px) {
    max-width: 450px;
    width: 90%;
    margin-top: -10px;
    flex-direction: column;
    height: auto;
    justify-content: flex-start;
    align-items: flex-start;
  }
`

export const HistoryContent = styled.section`
  width: 100%;
  margin-bottom: 30px;
  box-sizing: border-box;

  h1 {
    max-width: 1060px;
    margin-bottom: 25px;
    padding-bottom: 35px;
    border-bottom: 1px solid #d2dae4;
    font-family: StolzlMedium, sans-serif;
    font-size: 20px;
    line-height: 1.5;
    text-transform: uppercase;
  }

  p {
    max-width: 1060px;
  }

  .videoBlock {
    margin-top: -40px;
    margin-bottom: 40px;
    text-align: center;

    video {
      width: 100%;
      max-width: 800px;
      border-radius: 20px;
    }
  }
`
